import React from "react";
import CourseLockedBottomSheet from "../CourseLockedBottomSheet/CourseLockedBottomSheet";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { useTranslation } from "react-i18next";
import styles from "./LockedFreeCourseBottomSheet.module.scss"
import { useRouter } from "@src/lib/router";
import { enrollOnFreeCourse } from "@src/PaymentService/enrollForFreeCourse";
import { safeJsonParse } from "@src/utils/safeJsonParse";
const LockedFreeCourseBottomSheet = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showLockedFreeCourseBottomSheetAction
  );

  const orgId = useSelector((state) => state?.overviewReducer?.overViewDetails?.course
  ?.metaData?.orgId)

  const isUserSubscribedToFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isUserSubscribedToFreeCourse
  ) || 0;
  const remainingDaysForReSubscribe = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.remainingDaysForReSubscribe
  );
  const canRePurchaseFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.canRePurchaseFreeCourse
  );

  const freeCourseMarketingConfig = useSelector(
      (state) =>
        state?.overviewReducer?.overViewDetails?.course?.metaData?.freeCourseMarketingConfig
    ) || {};
  const item = safeJsonParse(localStorage.getItem("currentItem"), {
    source: "LockedFreeCourseBottomSheet [localStorage.currentItem]",
    fallback: {},
  });
  let isPurchased = item?.isPurchased;
  let isLocked = item?.isLocked;

  // let showBtn = isScheduled || (!isPurchased && isLocked) ? 1 : 0;
  let showBtn = isPurchased ? 0 : isLocked;

  const dispatch = useDispatch();

  function getDescription(){
    if(isUserSubscribedToFreeCourse){
      return <>You are already enrolled in a free course. Please come back after your free course expires.</>
    }
    if(!canRePurchaseFreeCourse){
      return (
        <>
          This course can be enrolled once in a month.<br />
          Please try after {remainingDaysForReSubscribe} {remainingDaysForReSubscribe > 1 ? "days" : "day"}
          {freeCourseMarketingConfig && freeCourseMarketingConfig.targetCourseId && (
            <>
              <br />
              or 
              <br />Please purchase full course to access content
            </>
          )}
        </>
      );
    }
    return <>You are already enrolled in a free course. Please come back after your free course expires.</>
  }

  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );

  const isFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isFreeCourse
  ) || 0;

  let customClasses = {
    btnText: '',
    viewAllSubText: '',
    parentContainer: ''
  };

  if(isFreeCourse){
    customClasses = {
      btnText: styles.FreeCourse__btnText,
      viewAllSubText: styles.FreeCourse__backBtn,
      parentContainer: styles.FreeCourse__wrapper
    };
  }
  return (
    <CourseLockedBottomSheet
      mainText={t(
        "components.bottomSheets.components.LockedFreeCourseBottomSheet.courseLocked",
        "Course Locked"
      )}
      btnText={"Go back instead"}
      subText={getDescription()}
      btnAction={() => {
        let deviceInfo = safeJsonParse(window?.androidData, {
          source: "LockedFreeCourseBottomSheet [window.androidData]",
          fallback: null,
        });
        let version = deviceInfo?.deviceInfo?.sdk
        if (version && version < 24 && (orgId == 573212 || orgId == 170)) {
          return dispatch(actionCreator.setNotSupportedBottomsheet(true));
        }
        dispatch(actionCreator.showLockedFreeCourseBottomSheetAction(false));
      }}
      state={state}
      showBtn={true}
      isCloseButtonVisible={false}
      customClasses={customClasses}
      // iconColor={"#5A5CD4"}
      dispatcher= {() => dispatch(actionCreator.showLockedFreeCourseBottomSheetAction(false))}
      successBtnText={"Buy full Course"}
      showSuccessBtn={freeCourseMarketingConfig && freeCourseMarketingConfig.targetCourseId }
      successBtnAction={()=>{
        dispatch(actionCreator.showLockedFreeCourseBottomSheetAction(false));
        if( freeCourseMarketingConfig && freeCourseMarketingConfig.targetCourseId ) {
          router.push(`/${freeCourseMarketingConfig.targetCourseId}/1`);
          setTimeout(() => {
            router?.reload();
          }, [100]);
        }
      }}
      isUserSubscribedToFreeCourse={isUserSubscribedToFreeCourse}
    />
  );
};

export default LockedFreeCourseBottomSheet;
